import { render, staticRenderFns } from "./ucit-performance-panel.vue?vue&type=template&id=54dbf03c&"
var script = {}
import style0 from "./ucit-performance-panel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports